import { render, staticRenderFns } from "./BookingCompletedThankYou.vue?vue&type=template&id=46b1fafe"
import script from "./BookingCompletedThankYou.vue?vue&type=script&lang=js"
export * from "./BookingCompletedThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports